import React, { useEffect, useState } from "react";
import { DesktopTimePicker, TabContext, TabList, TimePicker } from "@mui/lab";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Switch,
  Tab,
  TextField,
  Typography,
  tooltipClasses,
  Tooltip
} from "@mui/material";
import { styled } from "@mui/material/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
import { ToastContainer, toast } from "react-toastify";
import Cancel from "./../../../../assets/icons/close.png";

import LoadingView from "./../../../components/LoadingView/LoadingView.js";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal.js";
import axios from "axios";
import jwt_decode from "jwt-decode";

function VATSetupDialog(props) {
  // const { title } = props.title
  //Addsection dialog control start
  const [openAddKeyword, setOpenAddKeyword] = useState(false);

  const [openAddSection, setOpenAddSection] = useState(false);

  const [VatName, setVatName] = useState("");
  const [Parcentage, setParcentage] = useState(0);

  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);

  const { dialogType } = props;
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [loadingModal, SetloadingModal] = React.useState(false);

  const handleClose = () => {
    props.onHandleAddItem(false);
    setSelectedValue(null);
  };

  const [vatInsertView, setvatInsertView] = useState({
    Id: "",
    Name: "",
    Percentage: 0,
    RestaurantId: "",
    CreatorId: "",
    CreationDate: "05-02-2024",
    ModifierId: "",
    ModificationDate: "05-02-2024",
    IsActive: false,
    restaurantIds: [],
  });

  //AddSpecification modal open functionality
  const [open, setOpen] = useState(false);

  //Addsection dialog controll end

  //image upload code start

  //image upload code end
  const [tokenData, setTokenData] = useState({});

  const restaurant = JSON.parse(localStorage.getItem("restaurant"));
  const parentrestaurant = JSON.parse(localStorage.getItem("parentrestaurant"));

  const [userId, setUserId] = useState();

  // var decodedData = {};
  // if (token != null) {
  //     try {
  //         decodedData = jwt_decode(token)
  //         console.log(decodedData);
  //         setTokenData(decodedData)
  //     } catch (error) {
  //     }

  // }

  const [autoCompleteValue, setAutoCompleteValue] = React.useState([]);
  const [specificationRows, setSpecificationRows] = React.useState([]);
  const [restaurantDatas, setRestaurantDatas] = React.useState([]);
  const [restaurantAdded, setRestaurantAdded] = useState([]);
  const [RestaurantErr, setRestaurantErr] = useState(false);
  const apiAddress = process.env.REACT_APP_SECRET;

  const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));

  const token = localStorage.getItem("gotasteadmintoken");

  const loadRestaurantName = () => {
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) {}
    }
    console.log(decodedData.UserId);
    if (decodedData.UserId) {
      axios
        // .get(apiAddress + "/api/RestaurantUserMapper/getbyuserid/" + decodedData.UserId)
        .get(
          apiAddress +
            `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`
        )
        .then((response) => {
          var list = [];
          response.data.map((dt, i) => {
            var obj = {
              id: dt.restaurantId,
              title: dt.restaurantName,
            };
            list.push(obj);
          });
          console.log(list);
          setRestaurantDatas(list);
        });
    }
  };

  useEffect(() => {
  loadRestaurantName()
  }, []);

  const submit = () => {
    const token = localStorage.getItem("gotasteadmintoken");

    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        setTokenData(decodedData);
        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
        var list = [];
        list.push(obj);
      } catch (error) {}
    }

    let VatRestaurantMapperList = [];
    if(restaurantAdded.length>0){
      restaurantAdded.map((dt, i) => {
        VatRestaurantMapperList.push(dt.id);
        });
    }

    vatInsertView.Id = "1";
    vatInsertView.Name = VatName;
    vatInsertView.Percentage = Parcentage;
    vatInsertView.RestaurantId = parentrestaurant.id;
    vatInsertView.CreatorId = decodedData.UserId;
    vatInsertView.CreationDate = new Date().toISOString();
    vatInsertView.ModifierId = decodedData.UserId;
    vatInsertView.ModificationDate = new Date().toISOString();
    vatInsertView.IsActive = true;
    vatInsertView.restaurantIds = VatRestaurantMapperList 

    var valid = true;

    if (!!VatName == false) {
      toast.error("Vat Name Is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      console.log("hit");
      valid = false;
    }
    if (!!Parcentage == false) {
      toast.error("Value is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      console.log("hit");
      valid = false;
    }

    if (valid) {
      console.log("Api hit");
      SetloadingModal(true);
      axios({
        method: "post",
        url: apiAddress + "/api/Vat/PostVat",
        data: vatInsertView,
      }).then((response) => {
        console.log(response);
        setVatName("");
        setParcentage(0);
        SetloadingModal(false);
        toast.success("Successfully Saved", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        props.onHandleAddItem(false);
        setVatName("");
        setParcentage(0);
        setRestaurantAdded([])
      });
    }
    setopenConfirmaitonModal(false);
  };
  const restaurantAddedvalue = (newValue) => {
    setRestaurantAdded(newValue)
  }

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 320,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }));

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };


  return (
    <div>
      <React.Fragment>
        <Dialog
          fullWidth={true}
          className="addSectionDialog"
          open={props.open}
          onClose={handleClose}
        >
          <LoadingView open={loadingModal} close={closeLoadingModal} />
          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"You want to save this?"}
            open={openConfirmaitonModal}
            onyes={submit}
            close={() => {
              setopenConfirmaitonModal(false);
            }}
          />
          <ToastContainer />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <span style={{ color: "#2a7fd4" }}>
                    GoTaste :- {dialogType}
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={handleClose}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <div style={{ padding: "10px" }}>
          <Grid container sx={{ padding: "0.5rem" }}>
            <Grid item xs={3}>
              <div
                className="d-flex"
                style={{ paddingTop: "1rem", gap: "10px" }}
              >
                <Typography>Allow Restaurant</Typography>
                <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography color="inherit">
                          Selected restaurants will be able to manage this vat.
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoOutlinedIcon style={{ color: "#371B17" }} />
                  </HtmlTooltip>
              </div>
            </Grid>
            <Grid item xs={9}>
              {/* {EditRestaurant.length > 0 && restaurantDatas.length > 0 ? ( */}
              <AutoCompleteMultiSelect
                id={2}
                placeholder={"Restaurant"}
                datas={restaurantDatas}
                value={restaurantAddedvalue}
                val={restaurantAdded}
              />

              {/* ) : <img src={preloader} alt='preloader' style={{ width: '2rem' }} />
              } */}
              {RestaurantErr && (
                <span style={{ color: "red" }}>
                  This field is required
                </span>
              )}
            </Grid>
          </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={3}>
                <Typography style={{ paddingTop: "1rem" }}>Vat Name</Typography>
              </Grid>
              <Grid item xs={9}>
                <TextAreaComponents
                  label={"Vat name"}
                  value={setVatName}
                  val={VatName}
                ></TextAreaComponents>
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={3}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Percentage
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <TextAreaComponents
                  id={2}
                  label={"Percentage"}
                  value={setParcentage}
                  val={Parcentage}
                ></TextAreaComponents>
              </Grid>
            </Grid>

            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={10}></Grid>
              <Grid item xs={2}>
                <Button
                  className="AddItemButtons"
                  onClick={() => setopenConfirmaitonModal(true)}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </div>
          {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default VATSetupDialog;
